import { forwardRef, Icon, IconProps } from "@chakra-ui/react";
export default forwardRef<IconProps, "svg">((props, svgRef) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.667 8.956c.576 0 1.043.468 1.043 1.044v6.667a2.71 2.71 0 01-2.71 2.71H5a2.71 2.71 0 01-2.71-2.71V10a1.044 1.044 0 012.087 0v6.667A.623.623 0 005 17.29h10a.623.623 0 00.623-.623V10c0-.576.467-1.044 1.044-1.044zM10 .623a1.045 1.045 0 01.39.075l.037.017a.95.95 0 01.231.142 1.03 1.03 0 01.08.072l3.333 3.333a1.044 1.044 0 11-1.476 1.476l-1.552-1.552V12.5a1.044 1.044 0 11-2.087 0V4.186L7.405 5.738a1.044 1.044 0 01-1.476-1.476L9.262.93l.02-.02a.8.8 0 01.063-.055L9.262.93A1.044 1.044 0 0110 .623z"
      clipRule="evenodd"
    />
  </Icon>
));
